module.exports = __webpack_public_path__ + "static/media/sun.6b19c75c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/ImagesVideos/Sunlight/sun.gif
// module id = 323
// module chunks = 0